export const ADD_NEW_CARRIER = 'ADD_NEW_CARRIER';
export const EDIT_CARRIER = 'EDIT_CARRIER';
export const EDIT_CARRIER_FORM_PROPERTIES = 'EDIT_CARRIER_FORM_PROPERTIES';
export const LOAD_EDITABLE_CARRIER = 'LOAD_EDITABLE_CARRIER';
export const SET_EMPTY_EDITABLE_CARRIER = 'SET_EMPTY_EDITABLE_CARRIER';
export const SAVE_EDITABLE_CARRIER = 'SAVE_EDITABLE_CARRIER';
export const LOAD_CARRIERS = 'LOAD_CARRIERS';
export const SET_CARRIER_PAGINATION = 'SET_CARRIER_PAGINATION';
export const SET_CARRIER_FILTER = 'SET_CARRIER_FILTER';
export const SET_CARRIER_SORT = 'SET_CARRIER_SORT';
